export const Interactions = {
  AccountDataUpdate: 'account-data-update',
  LoginInfoEmailUpdate: 'login-info-email-update',
  LoginInfoPasswordUpdate: 'login-info-password-update',
  LoginInfoRecoverPassword: 'login-info-recover-password',
};
